import { api } from '@/lib/axios';

export interface CreditCardData {
  holderName: string;
  number: string;
  expiryMonth: string;
  expiryYear: string;
  ccv: string;
}

export interface CreditCardHolderInfo {
  cpfCnpj: string;
  postalCode: string;
  addressNumber: string;
  phone: string;
}

export interface PixPaymentResponse {
  order: any;
  pix: {
    qrCode: string; // Base64 do QR Code
    copyPaste: string; // Código PIX copia e cola
    expirationDate: string;
  };
}

export interface CreditCardPaymentResponse {
  order: any;
  payment: {
    id: string;
    status: string;
  };
}

export const paymentsService = {
  async createPixPayment(orderId: string): Promise<PixPaymentResponse> {
    const { data } = await api.post('/payments/pix', { orderId });
    return data;
  },

  async createCreditCardPayment(
    orderId: string,
    creditCard: CreditCardData,
    holderInfo: CreditCardHolderInfo,
    installments: number = 1,
  ): Promise<CreditCardPaymentResponse> {
    const { data } = await api.post('/payments/credit-card', {
      orderId,
      creditCard,
      holderInfo,
      installments,
    });
    return data;
  },

  async getPaymentStatus(orderId: string) {
    const { data } = await api.get(`/payments/status/${orderId}`);
    return data;
  },
};
